import { css, type Theme } from "@emotion/react";

import { animations } from "@styles";

export const button = (theme: Theme) => css`
  display: flex;
  padding: 0;
  ${animations.transition()};

  &:hover {
    progress,
    > div {
      background-color: ${theme.primary.backgroundMutedActive};

      &::-webkit-progress-bar {
        background-color: ${theme.primary.backgroundMutedActive};
      }
    }
  }
`;

const isFilled = (theme: Theme) => css`
  background-color: ${theme.primary.backgroundBase};
`;

export const progressBar = {
  base: (theme: Theme) => css`
    appearance: none;
    width: 38px;
    height: 4px;
    border: 0;
    overflow: hidden;
    border-radius: 6px;
    background-color: ${theme.primary.backgroundMutedHover};

    ::-webkit-progress-bar {
      background-color: ${theme.primary.backgroundMutedHover};
    }

    ::-webkit-progress-value {
      transition: width 0.1s;
      border-radius: 6px;
      ${isFilled(theme)};
    }

    ::-moz-progress-bar {
      transition: padding-bottom 0.1s;
      transform-origin: 0 0;
      transform: rotate(-90deg) translateX(-15px);
      padding-left: 15px;
      height: 0;
      ${isFilled(theme)};
    }

    ::-ms-fill {
      ${isFilled(theme)};
    }

    /* to prevent progress bar from bouncing back to 0 */
    &[value="0"] {
      ::-webkit-progress-value {
        transition: none;
      }

      ::-moz-progress-bar {
        transition: none;
      }
    }
  `,
  selected: (theme: Theme) => css`
    ${isFilled(theme)};

    ::-webkit-progress-bar {
      ${isFilled(theme)};
    }
  `,
  firefox: (value: number, autoplayDuration: number) => css`
    ::-moz-progress-bar {
      padding-bottom: calc(${value} / ${autoplayDuration} * 100%);
    }
  `,
};
